import type { Table } from '@tanstack/react-table'
import { DataTableRoot, DataTableContent, DataTableFooter } from '@components/molecules/DataTable'
import { TooltipProvider } from '@atoms/Tooltip'
import { scopedTranslation } from '@frontend/utils/I18n'
import type { SupporterEdge } from './useSupporterTable'

const t = scopedTranslation('group_show.table')

type SupporterDataTableProps = {
  table: Table<SupporterEdge>
  totalCount: number
  currentPage: number
  pageSize: number
}

export function SupporterDataTable({ table, totalCount, currentPage, pageSize }: SupporterDataTableProps) {
  return (
    <TooltipProvider>
      <DataTableRoot table={table}>
        <DataTableContent caption={t('table_caption')} />
        <DataTableFooter totalCount={totalCount} pageSize={pageSize} currentPage={currentPage} label={t('footer_label')} />
      </DataTableRoot>
    </TooltipProvider>
  )
}
